import {
  SET_STOCK_REPORT,
  SET_STOCK_REPORT_ERROR,
  SET_STOCK_REPORT_LOADING,
  SET_CURRENT_STOCK,
  SET_CURRENT_STOCK_ERROR,
  SET_CURRENT_STOCK_LOADING,
  SET_STOCK_MATERIAL_CONSUMPTION,
  SET_STOCK_MATERIAL_CONSUMPTION_ERROR,
  SET_STOCK_MATERIAL_CONSUMPTION_LOADING,
} from "../../actions/stockReportAction";

const initialState = {
  datas: null,
  loading: false,
  error: null,
  currentStock: null,
  currentStockLoading: false,
  currentStockError: null,
  materialConsumption: null,
  materialConsumptionLoading: false,
  materialConsumptionError: null,
};

const stockReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STOCK_REPORT:
      return {
        ...state,
        datas: action.data,
        error: null,
      };
    case SET_STOCK_REPORT_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    case SET_STOCK_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_CURRENT_STOCK:
      return {
        ...state,
        currentStock: action.data,
        currentStockError: null,
      };
    case SET_CURRENT_STOCK_LOADING:
      return {
        ...state,
        currentStockLoading: action.status,
      };
    case SET_CURRENT_STOCK_ERROR:
      return {
        ...state,
        currentStockLoading: false,
        currentStockError: action.error,
      };
    case SET_STOCK_MATERIAL_CONSUMPTION:
      return {
        ...state,
        materialConsumption: action.data,
        materialConsumptionError: null,
      };
    case SET_STOCK_MATERIAL_CONSUMPTION_LOADING:
      return {
        ...state,
        materialConsumptionLoading: action.status,
      };
    case SET_STOCK_MATERIAL_CONSUMPTION_ERROR:
      return {
        ...state,
        materialConsumptionLoading: false,
        materialConsumptionError: action.error,
      };
    default:
      return state;
  }
};

export default stockReportReducer;
